import React from "react";
import logo from "../assets/Logo/logo_validation.png";
import {Navigate} from "react-router-dom";
import {useAuth} from "oidc-react";
import SEO from "../components/SEO";
import {convertToBoolean} from "../utils/string.utils";
import {useHandleAuthentication} from "../handler/authHandler";

const pageSEOSettings = {
    title: "Login",
};

const {REACT_APP_SETTINGS_SHOW_LOGO} = process.env;

const Login = () => {
    const auth = useAuth();
    const {userData, isLoading} = useAuth();
    const {handleAuthentication} = useHandleAuthentication();

    if (userData && !isLoading) {
        handleAuthentication(userData);
        return <Navigate to={"/"}/>;
    }

    return (
        <div className="min-h-screen bg-[var(--primary-color)] flex flex-col md:flex-row">
            <SEO {...pageSEOSettings} />

            {/* Left branding panel — full width on mobile, fluid on desktop */}
            <div
                className="flex-1 flex flex-col justify-between
                           px-6 py-8 md:px-16 md:py-14
                           border-b border-white/10 md:border-b-0 md:border-r"
            >
                <div>
                    <div className="text-[var(--secondary-color)] text-2xl md:text-4xl font-amina tracking-wide">
                        Validation Station
                    </div>
                    {convertToBoolean(REACT_APP_SETTINGS_SHOW_LOGO) && (
                        <div className="flex items-center gap-2 mt-2 text-white/40 text-xs">
                            Part of
                            <img src={logo} alt="" className="h-4 opacity-60"/>
                        </div>
                    )}
                </div>

                {/* Tagline + footer hidden on mobile to keep the panel compact */}
                <div className="hidden md:block">
                    <div className="w-10 h-0.5 bg-[var(--secondary-color)]/40 mb-6"/>
                    <div className="text-white/20 text-xs leading-relaxed max-w-xs">
                        Intelligent invoice validation and processing platform.
                    </div>
                </div>

                <div className="hidden md:block text-white/20 text-xs">
                    &copy; {new Date().getFullYear()} ValidationStation
                </div>
            </div>

            {/* Right login panel — full width on mobile, fixed on desktop */}
            <div
                className="w-full md:w-[420px]
                           flex flex-col items-center justify-center
                           px-6 py-10 md:px-14 md:py-0
                           bg-black/10 flex-1 md:flex-none"
            >
                <div className="w-full max-w-sm">
                    <div className="text-white text-2xl md:text-3xl font-light mb-1">Welcome back</div>
                    <div className="text-white/40 text-sm mb-8 md:mb-10">
                        Sign in to your account to continue
                    </div>
                    <button
                        type="button"
                        onClick={auth.signIn}
                        className="w-full py-3 bg-white text-black text-sm font-medium rounded-full
                                   hover:bg-[var(--secondary-color)] hover:text-white
                                   transition-colors cursor-pointer border-0"
                    >
                        LOGIN
                    </button>
                </div>

                {/* Mobile-only footer for branding parity */}
                <div className="md:hidden text-white/20 text-[11px] mt-10">
                    &copy; {new Date().getFullYear()} ValidationStation
                </div>
            </div>
        </div>
    );
};

export default Login;
